import { Coordinate } from './coordinate';

export interface CoordinateHistory {
  id: number,
  accountId: number,
  importedLocationId: number,
  coordinates: Coordinate,
  source: CoordinateSource,
  createdDateTime: string // eg.: '2026-01-23T23:31:50.084625209'
}

export enum CoordinateSource {
  CUSTOM = 'CUSTOM',
  GBP = 'GBP', // accepted GBP coordinate diff
  GEOCODE = 'GEOCODE',
  IMPORT = 'IMPORT',
}